export default __webpack_public_path__ + "static/media/complete_selected.3f6b5d85.svg";